//hotpoints //elementy hover nia mają mieć satystyk ga360
window.dataLayer = window.dataLayer || [];

$('.hotpoints').find('.hotpoints--poi').on('hover touchend',function(){
    var current = $(this).index();
    if(!$(this).hasClass('__jsActive')) {
        $(this).parents('.hotpoints').find('.hotpoints--poi').removeClass('__jsActive');
        $(this).parents('.hotpoints').find('.hotpoints--desc').removeClass('__jsActive');
        $(this).addClass('__jsActive');
        $(this).parents('.hotpoints').find('.hotpoints--desc').eq($(this).index()).addClass('__jsActive');
        
        $(this).parents('.hotpoints').find('.hotpoints--mobile').addClass('__jsActive');
        
        var ga360id = $(this).parents('.hotpoints').data('ga360-id');
        var $artID = $(this).parents('.__js_stats_wrapper').data('id');
        
          if (ga360id == undefined) {
            console.log(
              '%c dodać ga360-id do Slider hotpoint: ' + $(this).data('id'),
              'background: #553311; padding: 3px; color: #ffaaaa'
            );
          } else {
            statElementCollector[ga360id + '-' + $artID] = {
              id: ga360id,
              moduleName: $(this).data('id'),
              viewedCount: 0,
              itemCount: $(this).parents('.hotpoints').find('.hotpoints--poi').length,
            };
          }
        
        //sendStats('hotpoint', 'hotpoint-'+current, '');
        //sendStats('hotpoint', 'click', $arId + ' / ' + $gId, $acId);
         if (!isScrolligFlag) {
            dataLayer.push({
              event: 'content_interaction',
              eventCategory: ga360id,
              moduleName: ga360id + ' / ' + $artID,
              eventAction: deviceTouch ? 'tap' : 'hover'
            });
          }
        
        if($(this).parents('.hotpoints').find('.hotpoints--mobile') && $(this).parents('.hotpoints').find('.hotpoints--mobile').outerHeight() != 0 ){
            console.log('to już');
            var txt = $(this).parents('.hotpoints').find('.hotpoints--poi-txt').eq($(this).index()).html();
            $(this).parents('.hotpoints').find('.hotpoints--mobile').text(txt);  
        } else { console.log('not yet'); }
    }
    else {
        
    }
});
$('.hotpoints').find('.hotpoints--poi').on('mouseleave',function(){
  $(this).parents('.hotpoints').find('.hotpoints--poi').removeClass('__jsActive');
  $(this).parents('.hotpoints').find('.hotpoints--desc').removeClass('__jsActive');
});
